/**
 * 核心 
 * @module Core
 */

;(function (ui,$) {
    
    
/**
 * 修改页面缩放比例,默认字体大小100px,手机端的字体大小大概在76px
 * @namespace bui
 * @class  viewport
 * @constructor 
 * @param  {number} size [默认页面的字体大小比例是100, bui会动态去计算该以多大展示]
 * @param  {number} base [设计稿大小基数540, bui会动态去计算该以多大展示]
 * @example
 *
     bui.ready(function(){
         //强制页面缩小一半的比例显示,例如在pc上面,正常无需再初始化,会自动计算
         window.viewport = bui.viewport(50);
     })
 *    
 */

function view(size,base) {
      var metaEl = document.querySelector('meta[name="viewport"]');
      var viewport = "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no";
      
      //是否需要动态创建viewport
      if (metaEl ) {

          metaEl.content = viewport ;
      } else {
          var element = document.createElement('meta');
              element.name = "viewport";
              element.content = viewport;
          var head = document.getElementsByTagName('head')[0];
              head.appendChild(element);
      }

      //计算缩放的比例
      var baseSize = 100, // 基数 
          baseWidth = base || 540,// 设计量的尺寸
          ratio = window.devicePixelRatio, //浏览器当前窗口可视区域宽度
          winWid = document.documentElement.clientWidth,     //浏览器当前窗口可视区域宽度
          winHei = document.documentElement.clientHeight,    //浏览器当前窗口可视区域宽度
          winWidth = parseInt(winWid) * parseInt(ratio),
          winHeight = parseInt(winHei) * parseInt(ratio),
          fontSize = size ? size : ( winWid / baseWidth * baseSize ).toFixed(2) ;
          size = fontSize;

      var domHtml = document.getElementsByTagName('html');

          domHtml[0].style.fontSize = fontSize + 'px';


      /**
       * 获取视口的宽度
       * @method width
       * @example
       *
          bui.ready(function(viewport){
              var width = viewport.width();
          })
       *
       */
      function getWidth (argument) {
          return winWid;
      }

      /**
       * 获取视口的高度
       * @method height
       * @example
       *
          bui.ready(function(viewport){
              var height = viewport.height();
          })
       *
       */
      function getHeight (argument) {
          return winHei;
      }
      /**
       * 获取的屏幕宽度分辨率
       * @method screenWidth
       * @example
       *
          bui.ready(function(viewport){
              var width = viewport.screenWidth();
          })
       *
       */
      function getScreenWidth (argument) {
          return winWidth;
      }
      /**
       * 获取的屏幕高度分辨率
       * @method screenHeight
       * @example
       *
          bui.ready(function(viewport){
              var height = viewport.screenHeight();
          })
       *
       */
      function getScreenHeight (argument) {
          return winHeight;
      }
      /**
       * 获取高清屏的dpi
       * @method ratio
       * @example
       *
          bui.ready(function(viewport){
              var ratio = viewport.ratio();
          })
       *
       */
      function getRatio (argument) {
          return ratio;
      }

      /**
       * 页面初始化main高度
       * @method init
       * @param {number} [num] [由于页面是rem布局,所以可能会存在1px的误差需要修正]
       * @example
       *
          bui.ready(function(viewport){
              viewport.init();
          })
       *
       */
      function init (num) {
        if( !document.getElementsByTagName('main')[0] ){
          return;
        }
          var num = num || 0;
          var headerObj = document.getElementsByTagName('header')[0];
          var footerObj = document.getElementsByTagName('footer')[0];
          var mainObj = document.getElementsByTagName('main')[0];
          var headHeight = headerObj ? headerObj.offsetHeight : 0;
          var footHeight = footerObj ? footerObj.offsetHeight : 0;

          // + 1 由于用rem缩放,在手机端会有大概1px的误差
          var mainHeight = winHei - headHeight - footHeight - num ;

          mainObj.style.height = mainHeight + 'px';

          return this;
      }

    return {
      width : getWidth,
      height : getHeight,
      fontSize : size,
      screenWidth : getScreenWidth,
      screenHeight : getScreenHeight,
      ratio : getRatio,
      init : init
    }
}

  ui.viewport = view;

  return ui;

})( bui || {}, libs );
